export const IS_NEXT_BUTTON_DISABLED = 'isNextButtonDisabled';
